module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown",
    class: {
      open: _vm.open
    }
  }, [_c('a', {
    directives: [{
      name: "click-out",
      rawName: "v-click-out",
      value: (_vm.hide),
      expression: "hide"
    }],
    attrs: {
      "href": "javascript://"
    },
    on: {
      "click": _vm.toggle
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus visible-xs-inline-block"
  }), _vm._v(" "), _c('span', [_vm._v("Novo")]), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'comitente.novo'
      }
    }
  }, [_vm._v("Comitente")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'leiloes.novo'
      }
    }
  }, [_c('span', [_vm._v("Leilão")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'usuario.novo'
      }
    }
  }, [_vm._v("Usuário Intranet")])], 1), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'banners.novo'
      }
    }
  }, [_c('span', [_vm._v("Banner")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'popup.novo'
      }
    }
  }, [_c('span', [_vm._v("Pop-up")])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02d6fa22","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/_default/components/header/DDNew.vue
// module id = 1642
// module chunks = 18